import tiresSvg from '../../assets/tires.svg';

export const TiresSvg = ({ width = 288, height = 174 }: { width?: number; height?: number }) => (
  <img src={tiresSvg} width={width} height={height} alt='' />
);
